/* Boon Nam -kilpailu landing · sticky bar, anchor scroll, Klaviyo success state */
(function () {
  'use strict';

  var root = document.querySelector('.tbg');
  if (!root) return;

  var signup = root.querySelector('.tbg-signup');
  var STORAGE_KEY = 'tbg:boon-nam:signed-up';
  var remember = root.getAttribute('data-remember') === 'true';

  function readFlag() {
    try { return remember && window.localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
  }
  function writeFlag() {
    try { if (remember) window.localStorage.setItem(STORAGE_KEY, '1'); } catch (e) { /* storage blocked */ }
  }

  /* Swap the sign-up card for the thank-you card (with the discount code) and relabel the CTAs. */
  function showSuccessState(options) {
    var card = root.querySelector('.tbg-signup__form');
    var template = root.querySelector('template.tbg-success-template');
    if (!card || !template || root.classList.contains('tbg--signed-up')) return;
    var successCard = template.content.cloneNode(true);
    card.innerHTML = '';
    card.appendChild(successCard);
    card.setAttribute('role', 'status');
    root.classList.add('tbg--signed-up');
    var introTitle = root.querySelector('.tbg-signup__title');
    var introLabel = root.getAttribute('data-success-intro');
    if (introTitle && introLabel) introTitle.textContent = introLabel;
    var ctaLabel = root.getAttribute('data-success-cta');
    if (ctaLabel) {
      root.querySelectorAll('a[href="#ilmoittaudu"]').forEach(function (link) { link.textContent = ctaLabel; });
    }
    if (options && options.remember) writeFlag();
    if (options && options.scroll && signup) {
      window.setTimeout(function () { signup.scrollIntoView({ behavior: 'auto', block: 'start' }); }, 50);
    }
  }

  /* Already signed up: Shopify form round-trip, Meta lead form → …#success, or remembered on this device */
  var params = new URLSearchParams(window.location.search);
  var viaUrl = window.location.hash === '#success' || params.has('success');
  var serverRendered = !!root.querySelector('.tbg-signup__form > .tbg-success');
  if (serverRendered) {
    writeFlag();
    root.classList.add('tbg--signed-up');
  } else if (viaUrl) {
    showSuccessState({ scroll: true, remember: true });
  } else if (readFlag()) {
    showSuccessState({ scroll: false, remember: false });
  }
  var heroCta = root.querySelector('.tbg-hero__cta');
  var sticky = root.querySelector('.tbg-sticky');
  var firstField = signup ? signup.querySelector('input[type="text"], input[type="email"]') : null;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- hero video: load the smallest useful source, desktop by default, never with reduced motion ---- */
  var heroVideo = root.querySelector('.tbg-hero__video');
  if (heroVideo && !prefersReducedMotion) {
    var isDesktop = window.matchMedia('(min-width: 768px)').matches;
    var wantsMobile = heroVideo.getAttribute('data-mobile') === 'true';
    if (isDesktop || wantsMobile) {
      var heights = Array.prototype.slice.call(heroVideo.attributes)
        .map(function (attr) { return attr.name.match(/^data-src-(\d+)$/); })
        .filter(Boolean)
        .map(function (match) { return parseInt(match[1], 10); })
        .sort(function (a, b) { return a - b; });
      var target = isDesktop ? 1080 : 720;
      var pick = heights.filter(function (h) { return h <= target; }).pop() || heights[0];
      if (pick) {
        heroVideo.addEventListener('playing', function () { heroVideo.classList.add('is-playing'); }, { once: true });
        heroVideo.src = heroVideo.getAttribute('data-src-' + pick);
        heroVideo.load();
        var playAttempt = heroVideo.play();
        if (playAttempt && playAttempt.catch) playAttempt.catch(function () { /* autoplay blocked: poster stays */ });
      }
    }
  }

  /* ---- anchor links → scroll to the form and focus the first field ---- */
  function scrollToForm(event) {
    if (!signup) return;
    event.preventDefault();
    signup.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
    var field = signup.querySelector('input[type="text"], input[type="email"]') || firstField;
    if (field) {
      window.setTimeout(function () { field.focus({ preventScroll: true }); }, prefersReducedMotion ? 0 : 450);
    }
  }
  root.querySelectorAll('a[href="#ilmoittaudu"]').forEach(function (link) {
    link.addEventListener('click', scrollToForm);
  });

  /* ---- "kilpailun säännöt" link in the consent line opens the rules accordion ---- */
  var rules = root.querySelector('#saannot details');
  root.querySelectorAll('a[href="#saannot"]').forEach(function (link) {
    link.addEventListener('click', function () {
      if (rules) rules.open = true;
    });
  });

  /* ---- sticky bar: visible once the hero CTA has scrolled out, hidden while the form is on screen ---- */
  if (sticky && heroCta && signup && 'IntersectionObserver' in window) {
    var heroGone = false;
    var formVisible = false;

    function update() {
      var show = heroGone && !formVisible;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        heroGone = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      });
      update();
    }, { threshold: 0 }).observe(heroCta);

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { formVisible = entry.isIntersecting; });
      update();
    }, { threshold: 0.15 }).observe(signup);
  }

  /* ---- Klaviyo embed: swap the form for the designed success card after submit ---- */
  var klaviyoHost = root.querySelector('.tbg-klaviyo');
  var successTemplate = root.querySelector('template.tbg-success-template');
  if (klaviyoHost && successTemplate) {
    var formId = klaviyoHost.getAttribute('data-form-id');
    var submitLabel = klaviyoHost.getAttribute('data-submit-label');

    var labelFirstName = klaviyoHost.getAttribute('data-label-first-name');
    var labelEmail = klaviyoHost.getAttribute('data-label-email');
    var placeholderEmail = klaviyoHost.getAttribute('data-placeholder-email');

    function setText(el, text) {
      if (el && text && el.textContent.trim() !== text) el.textContent = text;
    }
    function setPlaceholder(input, text) {
      if (input && text && input.getAttribute('placeholder') !== text) input.setAttribute('placeholder', text);
    }
    /* Klaviyo renders its own copy (button, labels, placeholders); rewrite to the section's
       settings whenever the form (re)renders so the embed reads exactly like the design. */
    function relabel() {
      klaviyoHost.querySelectorAll('button').forEach(function (button) {
        setText(button.querySelector('span') || button, submitLabel);
      });
      var emailInput = klaviyoHost.querySelector('input[type="email"]');
      var nameInput = klaviyoHost.querySelector('input[type="text"]');
      if (emailInput) {
        setText(klaviyoHost.querySelector('label[for="' + emailInput.id + '"]') || emailInput.parentElement.querySelector('label'), labelEmail);
        setPlaceholder(emailInput, placeholderEmail);
      }
      if (nameInput) {
        setText(klaviyoHost.querySelector('label[for="' + nameInput.id + '"]') || nameInput.parentElement.querySelector('label'), labelFirstName);
        setPlaceholder(nameInput, labelFirstName);
      }
    }
    new MutationObserver(relabel).observe(klaviyoHost, { childList: true, subtree: true });
    relabel();
    window.addEventListener('klaviyoForms', function (event) {
      var detail = event.detail || {};
      if (detail.type !== 'submit') return;
      if (formId && detail.formId && detail.formId !== formId) return;
      showSuccessState({ remember: true });
    });
  }

  /* ---- Designed form → Klaviyo client subscriptions API (no embed, exact design) ---- */
  var apiForm = root.querySelector('form[data-klaviyo-list]');
  var apiTemplate = apiForm && apiForm.querySelector('template.tbg-success-template');
  if (apiForm && apiTemplate) {
    apiForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = apiForm.querySelector('button[type="submit"]');
      var error = apiForm.querySelector('.tbg-form__error');
      var email = (apiForm.querySelector('input[type="email"]') || {}).value || '';
      var firstName = (apiForm.querySelector('input[type="text"]') || {}).value || '';
      var idleLabel = button.textContent;
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: apiForm.getAttribute('data-source') || 'Boon Nam -kilpailu',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email.trim(),
                  first_name: firstName.trim(),
                  properties: { boon_nam_kilpailu: true }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: apiForm.getAttribute('data-klaviyo-list') } } }
        }
      };
      var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' +
        encodeURIComponent(apiForm.getAttribute('data-klaviyo-company'));

      function fail() {
        if (error) error.hidden = false;
        button.disabled = false;
        button.textContent = idleLabel;
      }

      if (error) error.hidden = true;
      button.disabled = true;
      button.textContent = apiForm.getAttribute('data-sending-label') || idleLabel;

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (!response.ok) return fail();
        showSuccessState({ remember: true });
      }).catch(fail);
    });
  }

  /* ---- discount code: copy button inside the (dynamically inserted) success card ---- */
  root.addEventListener('click', function (event) {
    var button = event.target.closest('.tbg-code__copy');
    if (!button) return;
    var value = button.parentElement.querySelector('.tbg-code__value');
    var code = value ? value.getAttribute('data-code') : '';
    if (!code) return;
    var idleLabel = button.textContent;
    var done = function () {
      button.textContent = button.getAttribute('data-copied-label') || idleLabel;
      button.classList.add('is-copied');
      window.setTimeout(function () {
        button.textContent = idleLabel;
        button.classList.remove('is-copied');
      }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () { selectCode(value); });
    } else {
      selectCode(value);
      done();
    }
  });
  function selectCode(el) {
    if (!el || !window.getSelection) return;
    var range = document.createRange();
    range.selectNodeContents(el);
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  /* ---- Shopify fallback form: keep focus on the card after a server round-trip ---- */

})();
